import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Esto es para ligar?',
    a: 'Es mucho más profundo. Es un protocolo de carisma. Te sirve para que una mujer te encuentre fascinante, pero también para que en tu trabajo te respeten más y te conviertas en un líder natural.'
  }, {
    q: '¿Funciona si soy muy introvertido?',
    a: '¡Por supuesto! De hecho, está diseñado especialmente para quienes no somos "el alma de la fiesta". Son trucos mecánicos y ajustes en tu lenguaje corporal. No tienes que cambiar tu personalidad ni fingir ser alguien que no eres.'
  }, {
    q: '¿En cuánto tiempo veré resultados?',
    a: 'Los cambios en cómo te perciben los demás son inmediatos al aplicar los trucos de postura y contacto visual. Las conexiones más profundas se desarrollan conforme practicas el protocolo completo.'
  }, {
    q: '¿Es contenido digital o físico?',
    a: '100% digital. Tienes acceso inmediato después de tu compra. Lo puedes leer desde tu celular, tablet o computadora en cualquier momento.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. 7 días de garantía total. Si no te funciona, te devolvemos tu dinero sin hacerte preguntas. Así de seguros estamos del resultado.'
  }];
  return <section className="py-12 bg-surface-section" data-id="element-52">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="text-center mb-10" data-id="element-54">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-55">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, index) => <div key={index} className={`border border-surface-border rounded-xl bg-surface-card overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-gold/50' : ''}`} data-id="element-57">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-58">
                <span className="font-heading font-bold text-lg text-white pr-4" data-id="element-59">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-61">
                <p className="font-body text-gray-400 leading-relaxed" data-id="element-62">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}